export default __webpack_public_path__ + "static/media/i071vp.ca97786d.webp";